import { POST_API_PATH } from "../../../constants"
import apiSetting from "../apiSetting"

const getSMSCode = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_SMSCODE, data: data })
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const verifySMSCode = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_SEND_SMSCODE, data: data })
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

export { getSMSCode, verifySMSCode }
